module.exports = __webpack_public_path__ + "static/img/icon6-8.9b603900.png";